module.exports = __webpack_public_path__ + "assets/img/product-banner.1d2da764.png";